import { render, staticRenderFns } from "./EshopsEdit.vue?vue&type=template&id=2f1c7984&scoped=true"
import script from "./EshopsEdit.vue?vue&type=script&lang=js"
export * from "./EshopsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f1c7984",
  null
  
)

export default component.exports